import { keepPreviousData, useKyronQuery } from './kyronQuery';
import { useKyronMutation } from './kyronMutation';
import { LessonCollection, Pagination, QueryPaginationProps } from '../types';

export const useGetMarketplaceLessonCollections = ({ page = 1, perPage = 24 }: QueryPaginationProps) =>
  useKyronQuery<{
    lesson_collections: LessonCollection[];
    meta: Pagination;
  }>(`/lesson_collections/marketplace?page=${page}&per_page=${perPage}`, {
    queryKey: ['/lesson_collections', 'marketplace', page, perPage],
    placeholderData: keepPreviousData,
  });

export const useGetLessonCollection = (id: number) => useKyronQuery<LessonCollection>(`/lesson_collections/${id}`);

export const useDeleteLessonCollection = (lessonCollectionId: number) =>
  useKyronMutation<Record<string, unknown>>(`/lesson_collections/${lessonCollectionId}`, {
    method: 'DELETE',
    invalidatesMultiple: [['/lesson_collections/library'], ['/lessons'], [`/lesson_collections/${lessonCollectionId}`]],
  });

export const useGetLibraryLessonCollections = ({
  page = 1,
  perPage = 25,
  search,
}: { page?: number; perPage?: number; search?: string } = {}) => {
  const searchQueryStr = search ? `&q=${search}` : '';
  return useKyronQuery<{ lesson_collections: LessonCollection[]; meta: Pagination }>(
    `/lesson_collections/library?page=${page}&per_page=${perPage}${searchQueryStr}`,
    {
      queryKey: [`/lesson_collections/library`, { page, perPage, ...(search ? { search } : {}) }],
      placeholderData: keepPreviousData,
    },
  );
};

export const useGetAssignableCollections = ({
  page = 1,
  perPage = 25,
  search,
}: { page?: number; perPage?: number; search?: string } = {}) => {
  const searchQueryStr = search ? `&q=${search}` : '';
  return useKyronQuery<{ lesson_collections: LessonCollection[]; meta: Pagination }>(
    `/lesson_collections/assignable_collections?page=${page}&per_page=${perPage}${searchQueryStr}`,
    {
      queryKey: ['/lesson_collections/assignable_collections', { page, perPage, ...(search ? { search } : {}) }],
      placeholderData: keepPreviousData,
    },
  );
};
